import {
  Brain,
  CheckCircle2,
  CircleAlert,
  Lightbulb,
  MessageSquare,
  Sparkles,
  Trophy,
} from "lucide-react";

export const notificationStyles = {
  alert: {
    icon: CircleAlert,
    color: "var(--color-red)",
    bg: "var(--color-red-bg)",
  },
  survey: {
    icon: Lightbulb,
    color: "var(--color-purple)",
    bg: "#F0EDFF",
  },
  status_update: {
    icon: CheckCircle2,
    color: "var(--color-g700)",
    bg: "var(--color-green-bg)",
  },
  announcement: {
    icon: MessageSquare,
    color: "var(--color-blue)",
    bg: "var(--color-blue-bg)",
  },
  achievement: {
    icon: Trophy,
    color: "#D97706",
    bg: "var(--color-orange-bg)",
  },
  briefing: {
    icon: Sparkles,
    color: "var(--color-p500)",
    bg: "#F0EDFF",
  },
  action_plan: {
    icon: Brain,
    color: "var(--color-p700)",
    bg: "var(--color-p100)",
  },
};
